import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FileSelectorViewModel, ServerSideDataLoader } from "uicomponents";
import { PartNumber, PartNumberManipulationViewModel } from "./partNumberManipulation-viewModel"

export class PartNumberManipulationView extends View<PartNumberManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-B9F6D55D-2D66-49C8-BCA6-12DEF88DD91A"
    }
    loadHtml(): string {
        let element = require('./partNumberManipulation.html').default;
        let style = require('./partNumberManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set partNumbers(v: ObservableArray<PartNumber>) { this._partNumbers = v; } public get partNumbers(): ObservableArray<PartNumber> { return this._partNumbers;} private _partNumbers: ObservableArray<PartNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
    public set fromProductCode(v: string) { this._fromProductCode = v; } public get fromProductCode(): string { return this._fromProductCode;} private _fromProductCode: string;
    public set toProductCode(v: string) { this._toProductCode = v; } public get toProductCode(): string { return this._toProductCode;} private _toProductCode: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    import() {
        this.dataContext.import();
    }
    
    export() {
        this.dataContext.export();
    }

    requestPartNumberCreation(){
        this.dataContext.requestPartNumberCreation();
    }
}
